import { H4, Image, LI, P } from "../../../../AbstractElements";
import { Href } from "../../../../Constant";
import { SCROLLABLE_CONTENT_LIST } from "../../../../Data/Bonus Ui/Scrollable";

export const DynamicScrollableContent = () => {
  return (
    <>
      {SCROLLABLE_CONTENT_LIST.map(({ text, mail, days, src }, index) => (
        <LI tag="a" className="list-group-item-action list-hover-primary" href={Href} key={index}>
          <div className="list-wrapper gap-0">
            <Image className="list-img" src={src} alt="profile" />
            <div className="list-content">
              <H4>{text}</H4>
              <P>{mail}</P>
              <small className="text-muted">{days}</small>
            </div>
          </div>
        </LI>
      ))}
    </>
  );
};
